<template>
  <TextSetting v-bind="$attrs" :submitOverride="submitOverride">
    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>
  </TextSetting>
</template>

<script setup>
import TextSetting from "./TextSetting.vue";

function submitOverride(selectedCells, value) {
  selectedCells.forEach(async cell => {
    let tag = cell.componentArgs.tag;
    tag.committed = false;
    
    let system = tag.$session.system;
    let serverHostname = (system.cloudServer.value == "microventserver.gormancontrols.com")
      ? "api.register.gormancontrols.com"
      : system.cloudServer.value;
    
    let urlSetCompanyName = `http://${serverHostname}:2999/set-company-name`;
    try {
      let response = await fetch(urlSetCompanyName, {
        mode: "cors",
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ boardId: system.publicKey.value, companyName: value })
      });
      if (response.ok) {
        tag.committed = true;
      }
      else {
        throw `HTTP ${response.status} ${response.statusText}`
      }
    }
    catch (error) {
      // Log the error.
      console.error(error);
    }
  });
}
</script>